import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/wholesale")({
  head: () => ({
    meta: [
      { title: "Wholesale | Coyote Creek Hat Co." },
      { name: "description", content: "Interested in carrying Coyote Creek? Submit a wholesale inquiry and let's talk." },
      { property: "og:title", content: "Wholesale | Coyote Creek Hat Co." },
      { property: "og:description", content: "Partner with the best dadgum hat brand. Wholesale inquiries welcome." },
      { property: "og:url", content: "https://coyotecreekhatco.com/wholesale" },
    ],
    links: [{ rel: "canonical", href: "https://coyotecreekhatco.com/wholesale" }],
  }),
  component: WholesalePage,
});

function WholesalePage() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div>
      {/* Hero */}
      <div className="relative w-full h-[50vh] min-h-[320px] overflow-hidden">
        <img src="https://cdn.shopify.com/s/files/1/0808/1332/6620/files/EC448F7B-F1ED-42DC-A9DD-DDA1BFD726A0.jpg?v=1722660516" alt="Coyote Creek hats displayed in a retail setting" className="absolute inset-0 h-full w-full object-cover" width={1920} height={768} />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="font-heading text-5xl md:text-7xl uppercase tracking-[0.15em] text-white text-center px-6 drop-shadow-lg">Become a Dealer</h1>
        </div>
      </div>

      {/* Form */}
      <section className="py-20">
        <div className="mx-auto max-w-xl px-6">
          {submitted ? (
            <div className="rounded-2xl border border-border bg-card p-10 text-center">
              <h2 className="font-heading text-3xl text-primary">Thank You!</h2>
              <p className="mt-4 text-muted-foreground">We'll be in touch shortly. Looking forward to partnering with you.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="wholesale-business-name" className="font-ui text-sm font-semibold uppercase tracking-wider text-primary">Business Name</label>
                <input id="wholesale-business-name" name="businessName" required type="text" className="mt-2 w-full rounded-lg border border-border bg-card px-4 py-3 font-ui text-sm outline-none transition-colors focus:border-blaze" />
              </div>
              <div>
                <label htmlFor="wholesale-contact-name" className="font-ui text-sm font-semibold uppercase tracking-wider text-primary">Contact Name</label>
                <input id="wholesale-contact-name" name="contactName" required type="text" className="mt-2 w-full rounded-lg border border-border bg-card px-4 py-3 font-ui text-sm outline-none transition-colors focus:border-blaze" />
              </div>
              <div>
                <label htmlFor="wholesale-email" className="font-ui text-sm font-semibold uppercase tracking-wider text-primary">Email</label>
                <input id="wholesale-email" name="email" required type="email" className="mt-2 w-full rounded-lg border border-border bg-card px-4 py-3 font-ui text-sm outline-none transition-colors focus:border-blaze" />
              </div>
              <div>
                <label htmlFor="wholesale-phone" className="font-ui text-sm font-semibold uppercase tracking-wider text-primary">Phone</label>
                <input id="wholesale-phone" name="phone" type="tel" className="mt-2 w-full rounded-lg border border-border bg-card px-4 py-3 font-ui text-sm outline-none transition-colors focus:border-blaze" />
              </div>
              <div>
                <label htmlFor="wholesale-details" className="font-ui text-sm font-semibold uppercase tracking-wider text-primary">Tell us about your business</label>
                <textarea id="wholesale-details" name="details" required rows={4} className="mt-2 w-full rounded-lg border border-border bg-card px-4 py-3 font-ui text-sm outline-none transition-colors focus:border-blaze resize-none" />
              </div>
              <button
                type="submit"
                className="w-full btn-cc-accent tracking-wider"
              >
                Submit Inquiry
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
